import { IPassengerTable } from "../../../../../../interface/interfaces";

export const isValidPassengerData = (data: unknown): data is IPassengerTable => {
    if (typeof data !== 'object' || data === null) {
        return false;
    }

    const item = data as Record<string, unknown>;
    
    return (
        typeof item.Description === "string" &&
        typeof item.Content === "object" &&
        item.Content !== null
      );
}